import {AiFillLinkedin} from 'react-icons/ai'
import {AiOutlineTwitter} from 'react-icons/ai'
import {AiFillGithub} from 'react-icons/ai'

export const links = [
    {id: 1, link: '#', title: 'Home'},
    {id: 2, link: '#about', title: 'About'},
    {id: 3, link: '#portfolio', title: 'Portfolio'},
    {id: 4, link: '#contact', title: 'Contact'}
]


export const socials = [
    {id: 1, link: 'https://linkedin.com/in/alex-amankwah ', icon: <AiFillLinkedin/>},
    {id: 2, link: 'https://github.com/alexamankwah2', icon: <AiFillGithub/>},
    {id: 3, link: 'https://twitter.com', icon: <AiOutlineTwitter/>},
    
]